"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanCatalogItemDtoTierEnum = void 0;
exports.instanceOfPlanCatalogItemDto = instanceOfPlanCatalogItemDto;
exports.PlanCatalogItemDtoFromJSON = PlanCatalogItemDtoFromJSON;
exports.PlanCatalogItemDtoFromJSONTyped = PlanCatalogItemDtoFromJSONTyped;
exports.PlanCatalogItemDtoToJSON = PlanCatalogItemDtoToJSON;
exports.PlanCatalogItemDtoToJSONTyped = PlanCatalogItemDtoToJSONTyped;
/**
 * @export
 */
exports.PlanCatalogItemDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the PlanCatalogItemDto interface.
 */
function instanceOfPlanCatalogItemDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('billingCycle' in value) || value['billingCycle'] === undefined)
        return false;
    if (!('isMostPopular' in value) || value['isMostPopular'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('featureGroups' in value) || value['featureGroups'] === undefined)
        return false;
    return true;
}
function PlanCatalogItemDtoFromJSON(json) {
    return PlanCatalogItemDtoFromJSONTyped(json, false);
}
function PlanCatalogItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'displayName': json['displayName'],
        'tier': json['tier'],
        'billingCycle': json['billingCycle'],
        'isMostPopular': json['isMostPopular'],
        'appleProductId': json['appleProductId'] == null ? undefined : json['appleProductId'],
        'googlePlayProductId': json['googlePlayProductId'] == null ? undefined : json['googlePlayProductId'],
        'price': json['price'],
        'featureGroups': json['featureGroups'],
    };
}
function PlanCatalogItemDtoToJSON(json) {
    return PlanCatalogItemDtoToJSONTyped(json, false);
}
function PlanCatalogItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'displayName': value['displayName'],
        'tier': value['tier'],
        'billingCycle': value['billingCycle'],
        'isMostPopular': value['isMostPopular'],
        'appleProductId': value['appleProductId'],
        'googlePlayProductId': value['googlePlayProductId'],
        'price': value['price'],
        'featureGroups': value['featureGroups'],
    };
}
